import { motion } from "framer-motion";
import { Reveal, MaskedLine } from "@/components/site/Reveal";
import { useLang } from "@/i18n";

const Privacy = () => {
  const { d } = useLang();
  const p = d.privacy;
  return (
    <div data-testid="privacy-page">
      <section className="bg-paper py-20 lg:py-28">
        <div className="mx-auto max-w-4xl px-6 sm:px-8 lg:px-12">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-accent"
          >
            <span className="h-px w-10 bg-accent" /> {p.label}
          </motion.p>
          <h1 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-testid="privacy-headline">
            <MaskedLine delay={0.1}>
              {p.titleA} <span className="italic text-accent">{p.titleB}</span>
            </MaskedLine>
          </h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }} className="mt-6 text-sm text-mutedink">
            {p.updated}
          </motion.p>
          <div className="mt-14 divide-y divide-ink/10 border-y border-ink/10">
            {p.sections.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.04} className="grid gap-3 py-7 sm:grid-cols-12">
                <h2 className="font-serif text-xl font-normal text-ink sm:col-span-4">
                  <span className="mr-3 font-mono text-xs text-accent">{String(i + 1).padStart(2, "0")}</span>
                  {s.t}
                </h2>
                <p className="text-sm leading-relaxed text-mutedink sm:col-span-8" data-testid={`privacy-section-${i}`}>
                  {s.b}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
